// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.62484564f',
  revision: '62484564f',
  branch: 'develop',
  date: 'Tue, 22 Sep 2026 16:14:19 GMT'
};